document.addEventListener('DOMContentLoaded', function () {
  // Funzione che aggiorna il badge del carrello nell'header
  function updateHeaderCartCount() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var count = cart.item_count;

        // Tutti gli elementi del tema che mostrano il numero prodotti
        var countEls = document.querySelectorAll('[data-cart-count]');

        countEls.forEach(function (el) {
          // Caso badge: <div data-cart-count><span>5</span></div>
          if (el.tagName === 'DIV') {
            var span = el.querySelector('span');
            if (span) span.textContent = count;
          } else {
            // Caso testo: (5)
            el.textContent = '(' + count + ')';
          }
        });
      })
      .catch(function (err) {
        console.error('Errore aggiornando il contatore carrello:', err);
      });
  }

  // 1) Sync immediata al load
  updateHeaderCartCount();

  // 2) Sync quando il TEMA emette l'evento cart:update (cart.js)
  document.addEventListener('cart:update', function () {
    updateHeaderCartCount();
  });

  // 3) Sync periodica per beccare anche le modifiche fatte da Cartly
  //    (es. ogni 3 secondi)
  setInterval(updateHeaderCartCount, 3000);
});
